/**
 * Filnavnet på rapporten.
 *
 * Versjonsnummeret inngår, slik at en oppdatert rapport ikke kolliderer med
 * den forrige hos mottakeren. Se docs/05-modul-logg.md.
 */

export interface ReportNaming {
  readonly production: string;
  readonly shootDay: string;
  readonly dateIso: string;
  readonly unit: string;
  readonly shift: string;
  readonly initials: string;
  readonly version: number;
}

/**
 * æ, ø og å byttes ut, og alt som ikke er bokstav eller tall fjernes.
 *
 * Store bokstaver forblir store: «Øya» blir «Oya», ikke «oya». Filnavnet
 * leses av et menneske som skal kjenne igjen produksjonen sin.
 */
export function slug(value: string): string {
  return value
    .replace(/æ/g, "ae")
    .replace(/Æ/g, "Ae")
    .replace(/ø/g, "o")
    .replace(/Ø/g, "O")
    .replace(/å/g, "a")
    .replace(/Å/g, "A")
    .replace(/[^A-Za-z0-9]/g, "");
}

export function reportStem(n: ReportNaming): string {
  /*
   * Opptaksdag er tekst, ikke tall. «12A» er helt vanlig i norsk produksjon,
   * og Number() gjorde den til NaN — filnavnet ble Oya_DNaN_…, og det er
   * filnavnet redaktoer sorterer etter.
   */
  const raa = n.shootDay.trim();
  const day = /^\d+$/.test(raa) ? raa.padStart(2, "0") : slug(raa);
  // Mangler enhet, vises det som en tydelig tom plass.
  const unit = n.unit.trim().length > 0 ? slug(n.unit) : "____";
  return [
    slug(n.production),
    `D${day}`,
    n.dateIso,
    unit,
    slug(n.shift),
    slug(n.initials),
    `v${n.version}`,
  ].join("_");
}

export function reportFilename(n: ReportNaming): string {
  return `${reportStem(n)}.pdf`;
}
